export default __webpack_public_path__ + "c7b11e176074d2aa854ab69ee68d3b68606fa698d7ee8b1d0b2fa244f94f9f8b.png";